import {
  SparklesIcon,
  HomeIcon,
  ShowerHeadIcon,
  UtensilsIcon,
  TruckIcon,
  StarIcon,
} from 'lucide-react'
import type { Service } from '../types'

export const services: Service[] = [
  {
    id: 'deep',
    icon: SparklesIcon,
    title: { en: 'Deep Cleaning', es: 'Limpieza Profunda' },
    description: {
      en: 'Complete home deep clean — every room thoroughly cleaned, top to bottom.',
      es: 'Limpieza profunda completa del hogar: cada habitación limpiada a fondo.',
    },
    features: [
      { en: 'Walls & baseboards', es: 'Paredes y zócalos' },
      { en: 'Ceiling fans & vents', es: 'Ventiladores y rejillas' },
      { en: 'Appliances inside & out', es: 'Electrodomésticos por dentro y fuera' },
      { en: 'Deep scrubbing throughout', es: 'Fregado profundo en todo el hogar' },
    ],
    duration: { en: '4–6 hours', es: '4–6 horas' },
    ctaKey: 'book',
    featured: true,
  },
  {
    id: 'regular',
    icon: HomeIcon,
    title: { en: 'Regular Cleaning', es: 'Limpieza Regular' },
    description: {
      en: 'Recurring maintenance cleaning that keeps your home consistently fresh.',
      es: 'Limpieza de mantenimiento recurrente para mantener su hogar siempre fresco.',
    },
    features: [
      { en: 'Dusting & vacuuming', es: 'Quitar polvo y aspirar' },
      { en: 'Mopping all floors', es: 'Trapear todos los pisos' },
      { en: 'Bathrooms sanitized', es: 'Baños desinfectados' },
      { en: 'Kitchen wipe-down', es: 'Limpieza de cocina' },
    ],
    duration: { en: '2–3 hours', es: '2–3 horas' },
    ctaKey: 'book',
  },
  {
    id: 'bathroom',
    icon: ShowerHeadIcon,
    title: { en: 'Bathroom Deep Clean', es: 'Limpieza Profunda de Baño' },
    description: {
      en: 'Professional bathroom cleaning and full sanitizing service.',
      es: 'Limpieza y desinfección profesional completa del baño.',
    },
    features: [
      { en: 'Tub & tile scrubbing', es: 'Fregado de tina y azulejos' },
      { en: 'Disinfection of all surfaces', es: 'Desinfección de superficies' },
      { en: 'Grout cleaning', es: 'Limpieza de juntas' },
      { en: 'Streak-free mirrors', es: 'Espejos sin marcas' },
    ],
    duration: { en: '1–1.5 hours', es: '1–1.5 horas' },
    ctaKey: 'book',
  },
  {
    id: 'kitchen',
    icon: UtensilsIcon,
    title: { en: 'Kitchen Deep Clean', es: 'Limpieza Profunda de Cocina' },
    description: {
      en: 'Complete kitchen cleaning including appliances, inside and out.',
      es: 'Limpieza completa de cocina incluyendo electrodomésticos por dentro y fuera.',
    },
    features: [
      { en: 'Cabinet fronts', es: 'Frentes de gabinetes' },
      { en: 'Appliances degreased', es: 'Electrodomésticos desengrasados' },
      { en: 'Counters & backsplash', es: 'Mesones y salpicadero' },
      { en: 'Sink deep scrubbing', es: 'Fregado profundo del fregadero' },
    ],
    duration: { en: '1.5–2 hours', es: '1.5–2 horas' },
    ctaKey: 'book',
  },
  {
    id: 'move',
    icon: TruckIcon,
    title: { en: 'Move-In / Move-Out', es: 'Mudanza de Entrada / Salida' },
    description: {
      en: 'Complete empty-home cleaning so you hand over — or move into — a spotless space.',
      es: 'Limpieza completa de casa vacía para entregar o mudarse a un espacio impecable.',
    },
    features: [
      { en: 'Inside all cabinets', es: 'Interior de gabinetes' },
      { en: 'Walls & doors', es: 'Paredes y puertas' },
      { en: 'Carpets & floors', es: 'Alfombras y pisos' },
      { en: 'Windows & tracks', es: 'Ventanas y rieles' },
    ],
    duration: { en: '6–8 hours', es: '6–8 horas' },
    ctaKey: 'book',
  },
  {
    id: 'specialized',
    icon: StarIcon,
    title: { en: 'Specialized Services', es: 'Servicios Especializados' },
    description: {
      en: 'Add-on services for the jobs that need extra attention.',
      es: 'Servicios adicionales para las tareas que necesitan atención extra.',
    },
    features: [
      { en: 'Carpet cleaning', es: 'Limpieza de alfombras' },
      { en: 'Window washing', es: 'Lavado de ventanas' },
      { en: 'Laundry service', es: 'Servicio de lavandería' },
      { en: 'Organizing', es: 'Organización' },
    ],
    ctaKey: 'viewAll',
  },
]
